import React from 'react';
import PropTypes from 'prop-types';
import { Text, Toast } from 'react-orange-ui';
import { ArrowLink } from 'react-onei';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';
import { addWhiteListPage } from "../../../actions/GenericActions";
import Space from '../../../orange-ui/components/Spaces/Space';

export class GetLetter extends React.Component {
    componentDidMount() {
        const { addWhiteListPage } = this.props;

        addWhiteListPage('letter');
    }

    render() {
        const { order } = this.props;

        return (
            <div style={{ order }}>
                <Text as="h3" bold size="m" id="get-letter-label">
                    {WordingService.getWording('caption', 'askNewTmpPwd')}
                </Text>
                <Space size="s" />
                <Text size="s" id="get-letter-delay">
                    {WordingService.getWording('caption', 'getLetter')}
                </Text>
                <Space size="m" />
                <ArrowLink
                    as={Link}
                    to="/letter"
                    id="get-letter-link"
                    onClick={() => TagService.sendAction('getLetter')}
                    aria-label="Recevoir un nouveau mot de passe provisoire par courrier"
                    title="Recevoir un nouveau mot de passe provisoire par courrier"
                >
                    {WordingService.getWording('link', 'getNewTemporaryPassword')}
                </ArrowLink>
                <Space size="m" />
                <Toast type="info" size="m">
                    <Text bold size="s" id="sav-advise-message">
                        {WordingService.getWording('caption', 'savSameAdvice')}
                    </Text>
                </Toast>
                <Space size="l" />
            </div>
        )
    }
};

GetLetter.defaultProps = {
    addWhiteListPage: () => { },
    order: 0,
}

GetLetter.propTypes = {
    addWhiteListPage: PropTypes.func,
    order: PropTypes.number,
};

const mapDispacthToProps = dispatch => ({
    addWhiteListPage: page => dispatch(addWhiteListPage(page)),
});

export default connect(
    null,
    mapDispacthToProps,
)(GetLetter);